import { MdOutlineAdd, MdOutlineRemove } from 'react-icons/md';
import { IoMdTrash } from 'react-icons/io';
import ReactTooltip from 'react-tooltip';

import { QuantityChangeEvents } from '../../types';
import QuantityButton from './components/QuantityButton';
import getQuantityCountTooltip from '../../helpers/getQuantityCountTooltip';

type Props = {
  tierId: string;
  selectedTicketTierQuantity: number;
  onQuantityChange: (event: QuantityChangeEvents) => void;
  totalAmountOfTicketsSelected: number;
  maxTicketsPerTransaction: number;
  remainingTicketsForTier: number;
};

const QuantityButtons = ({
  tierId,
  selectedTicketTierQuantity,
  onQuantityChange,
  totalAmountOfTicketsSelected,
  maxTicketsPerTransaction,
  remainingTicketsForTier
}: Props) => {
  const updateQuantity = (event: QuantityChangeEvents) => () => {
    onQuantityChange(event);
  };

  const tooltipContent = getQuantityCountTooltip(
    selectedTicketTierQuantity,
    totalAmountOfTicketsSelected,
    remainingTicketsForTier,
    maxTicketsPerTransaction
  );

  if (selectedTicketTierQuantity === 0) {
    return (
      <div className="bg-black text-white rounded-full flex align-center justify-center h-[30px] w-[30px]">
        <MdOutlineAdd size={24} />
      </div>
    );
  }

  return (
    <>
      {tooltipContent && (
        <ReactTooltip
          id={`ticket-info-tooltip-${tierId}`}
          place="right"
          effect="solid"
        >
          <div className="w-52">
            <p>{tooltipContent}</p>
          </div>
        </ReactTooltip>
      )}
      <div
        data-tip
        data-for={`ticket-info-tooltip-${tierId}`}
        className="bg-black text-white rounded-3xl flex align-center justify-center"
      >
        <QuantityButton
          onClick={updateQuantity(QuantityChangeEvents.Decrease)}
          disabled={totalAmountOfTicketsSelected <= 0}
        >
          {selectedTicketTierQuantity === 1 ? (
            <IoMdTrash size={24} className="ml-1" />
          ) : (
            <MdOutlineRemove size={24} />
          )}
        </QuantityButton>
        <div className="text-lg font-normal">
          {String(selectedTicketTierQuantity).padStart(2, '0')}
        </div>
        <QuantityButton
          disabled={
            totalAmountOfTicketsSelected >= maxTicketsPerTransaction ||
            selectedTicketTierQuantity >= remainingTicketsForTier
          }
          onClick={updateQuantity(QuantityChangeEvents.Increase)}
        >
          <MdOutlineAdd size={24} />
        </QuantityButton>
      </div>
    </>
  );
};
export default QuantityButtons;
